import {Component} from '@angular/core';
import {ViewController, NavParams} from 'ionic-angular';
import {MembershipService} from '../../../../profile/membership/membership.service';

@Component({
  selector: 'page-extra-class',
  templateUrl: 'extra-class.html'
})
export class ExtraClassPage {

  public price: number;

  constructor(private readonly viewCtrl: ViewController,
              private readonly navParams: NavParams,
              public readonly membershipService: MembershipService) {
    this.price = navParams.get('price');
  }

  dismissModal(extras = false) {
    this.viewCtrl.dismiss(extras);
  }

  accept() {
    this.dismissModal(true)
  }

  cancel() {
    this.dismissModal()
  }

}



// WEBPACK FOOTER //
// ./src/pages/tabs/shared/class/confirm/extra-class/extra-class.ts